import { z } from 'zod';
/**
 * The email round-trip test — Settings → Email.
 *
 * Outbound: the worker sends the signed-in person one message and records
 * whether the relay took it. Inbound: once reply-by-email exists (see
 * docs/email-ingestion.md) a reply to that message completes the loop; until
 * then the inbound half reports `not-configured` rather than pretending.
 *
 * State lives in Redis for a day, one record per user. It is a diagnostic,
 * not history, so it is not a table.
 */
export const emailTestStatusSchema = z.enum(['queued', 'sent', 'failed']);
export const emailTestInboundStatusSchema = z.enum(['not-configured', 'waiting', 'received']);
export const emailTestSchema = z.object({
    id: z.string().uuid(),
    to: z.string(),
    status: emailTestStatusSchema,
    requestedAt: z.string().datetime(),
    finishedAt: z.string().datetime().nullable(),
    messageId: z.string().nullable(),
    /** The relay's or driver's message when `status` is `failed`. */
    error: z.string().nullable(),
    inbound: z.object({
        status: emailTestInboundStatusSchema,
        receivedAt: z.string().datetime().nullable(),
    }),
});
export const emailTestStateSchema = z.object({ test: emailTestSchema.nullable() });
//# sourceMappingURL=email-test.js.map